import axios from 'axios';
import { CORE_API_BASE_URL, APP_KEY } from '../constants/index';
import { tokenStore, refreshSessionOnce } from './core';

/**
 * Client autenticado pro Core (/v1/...) usado por features que falam direto com
 * o Core no browser (equipe/memberships, apps da suíte, SSO). Anexa o Bearer do
 * usuário + X-Company-Id (empresa ativa) + X-App-Key. CORS do Core já libera o
 * domínio do Task.
 */
export const coreAuthed = axios.create({
  baseURL: CORE_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

coreAuthed.interceptors.request.use((config) => {
  const access = tokenStore.getAccess();
  if (access) config.headers.Authorization = `Bearer ${access}`;
  const cid = tokenStore.getCompanyId();
  if (cid) config.headers['X-Company-Id'] = cid;
  config.headers['X-App-Key'] = APP_KEY;
  return config;
});

// Mesmo refresh-then-retry do api.ts (o access token do Core dura ~15min). Usa o
// single-flight compartilhado pra não conflitar com o refresh do api.ts.
coreAuthed.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      try {
        const data = await refreshSessionOnce();
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return coreAuthed(original);
      } catch (_e) {
        /* refresh falhou — deixa o 401 propagar (api.ts trata o logout). */
      }
    }
    return Promise.reject(error);
  },
);
